<template>
  <div class="pt-4">
    <hr class="pb-2">
    <div class="hidden lg:grid grid-cols-12 lg3:grid-cols-11 items-center w-full text-sm">
      <div 
        class="w-content cursor-pointer col-span-2 lg3:col-span-1 Avenir-LT-Pro-class"
        :class="{'text-green-light': selectedCategory === 'All Categories'}"
        @click="$emit('handleCategoryReset')"
      >
        All Categories  
      </div>
      <carousel 
        :settings="settings" 
        :breakpoints="breakpoints" 
        :wrapAround="true"
        class="col-span-10 h-5/6"
      >
        <slide v-for="category in freelancerCategories" :key="category.category_id_token">
          <div class="inline-flex items-center justify-center category-slide">
            <span
              class="cursor-pointer tracking-tighter px-2" 
              :class="[selectedCategory === category.category_id_token ? 'text-green-light' : 'null']"
              @click="$emit('handleCategoryClick',category.category_id_token, 1)"
            >
              {{ category.category_name }}
            </span>
          </div>
        </slide>
        <template #addons="{ slidesCount }">
          <navigation v-if="slidesCount > 1"/>
        </template>
      </carousel>
    </div>
    <select
      v-model="selectedCategory"
      class="lg:hidden bg-white pl-3 pr-12 w-full"
      :class="{'text-green-light': selectedCategory}"
      @change="$emit('handleCategoryClick',selectedCategory,1)"
    >
      <option :value="null" disabled>Select a category</option>
      <option value="All Categories" class="text-black p-2">All Categories</option>
      <option
        v-for="(option, index) in freelancerCategories"
        :key="`option-${index}`"
        :value="option.category_id_token"
        class="text-black p-2"
      >
        {{ option.category_name }}
      </option>
    </select>
    <hr class="mt-2 mb-5">
  </div>  
</template>

<script>
import { Carousel, Navigation, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

export default {
  components: {
    Carousel,
    Slide,
    Navigation
  },
  props:{
    freelancerCategories:{
      type: Array,
      default: () => []
    },
    selectedCategoryId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      selectedCategory: this.selectedCategoryId,
      // carousel settings
      settings: {
        itemsToShow: 1,
        snapAlign: 'start',
      },
      breakpoints: {
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: 'start',
          itemsToScroll: 3
        },
        1200: {
          itemsToShow: 5,
          snapAlign: 'start',
          itemsToScroll: 5
        },
        1460: {
          itemsToShow: 8,
          snapAlign: 'start',
          itemsToScroll: 8
        }
      },
    }
  },
  watch: {
    selectedCategoryId(val) {
      this.selectedCategory = val
    }
  },
}
</script>

<style scoped lang="scss">
  :deep() .carousel__prev, /deep/.carousel__next {
    @apply bg-white text-black;
  }
  :deep() .carousel__slide carousel__slide--visible {
    width: 6%;
  }
  :deep().carousel__next {
    @apply h-full;
    transform: translate(60%, -50%);
    color: #B2B2B2
  }
  :deep().carousel__prev {
    @apply h-full;
    transform: translate(-60%, -50%);
    color: #B2B2B2
  }
  :deep().carousel__slide {
    @apply border-r-2;
  }
  :deep().carousel__viewport {
    @apply h-full;
  }
  .h-5\/6 {
    height: 100%;
  }
  .category-slide {
    padding: 2%;
  }
  .text-green-light{
    font-family: 'Avenir LT Pro' !important;
    color: #27B373 !important;
  }
  .Avenir-LT-Pro-class {
    font-family: 'Avenir LT Pro' !important;
  }
</style>